export default __webpack_public_path__ + "media/images/badge-level2-size34-1a33c454ad1f3498cea9608d04c78662.png";